import type {
  TUser,
  TUserServer,
  TUsersResponse,
  TUsersResponseServer,
} from '../../store/types';

const userItemAdapter = (item: TUserServer): TUser => ({
  id: item.id,
  email: item.email,
  name: item.name,
  role: item.role,
  created: item.created,
  partnerId: item.partner_id,
});

export const usersAdapter = ({ count, items }: TUsersResponseServer): TUsersResponse => ({
  count,
  items: items.map(userItemAdapter),
});
